<template>
    <v-layout>
        
            <v-app-bar :color="appbarcolor" density="compact">
                <template v-slot:prepend>
                <v-app-bar-nav-icon variant="text" v-if="authStore.isUserLoggedIn" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
                </template>
                <template v-slot:append>
                <v-btn v-if="!authStore.isUserLoggedIn" @click="login" >Login</v-btn>
                <v-btn v-if="authStore.isUserLoggedIn" @click="logout">Logout</v-btn>
                </template>
                <v-app-bar-title>G.M.Pharmaceuticals</v-app-bar-title>
            </v-app-bar>
            <v-navigation-drawer
                v-model="drawer"
                :location="$vuetify.display.mobile ? 'bottom' : undefined"
                temporary
            >
                <v-list>
                    <template v-for="item in items" :key="item.title">
                        <v-list-item
                            v-if="authStore.roles.includes(item.role)"                      
                            :to="item.link"
                            :title="item.title"
                        >
                        </v-list-item>
                    </template>
                </v-list>
                <v-list-group value="Reports">
                    <template v-slot:activator="{ props }">
                        <v-list-item
                            v-bind="props"
                            title="Reports"
                        ></v-list-item>
                    </template>
                </v-list-group>
            </v-navigation-drawer>
    </v-layout>  
</template>

<script setup>
  import { ref } from 'vue'
  import { useAuthStore } from '@/stores/AuthStore'
  import router from '@/router'

  const drawer = ref(false)
  const authStore = useAuthStore()

  //const appbarcolor = process.env.
  const environment = process.env.NODE_ENV

  const appbarcolor = ref((environment === 'development') ? '#546B41' : 'primary')

  const items = [
    {title: 'Home', link: '/', role: 'guest' },
    {title: 'Batches', link: '/batches', role: 's_create-bill' },
    {title: 'Bills', link: '/bills', role: 's_create-bill' },
    {title: 'Purchase', link: '/purchase', role: 's_create-bill' },
    {title: 'GST', link: '/gst', role: 's_create-bill' },
    {title: 'Stock', link: '/stock', role: 's_create-bill' },
    {title: 'Ledger', link: '/partyledger', role: 's_create-bill' }
  ]

  function login() {
    router.push('/login')
  }

  function logout() {
    authStore.$reset()
  }
  
</script>